import React from 'react';

// Helper funktion til at parse links i teksten
const parseLinks = (text, subdomain) => {
    // Matches [link text](url)
    const linkRegex = /\[([^\]]+)\]\(([^)]+)\)/g;
    
    // Split tekst ved links og konverter til JSX
    const parts = text.split(linkRegex);
    
    return parts.map((part, i) => {
      if (i % 3 === 1) {
        // Link tekst
        const linkText = part;
        let url = parts[i + 1];
  
        // Hvis det er et internt link (starter med /)
        if (url.startsWith('/')) {
          const hostname = window.location.hostname;
          const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';
          
          if (isLocalhost) {
            // På localhost, brug CVR nummer routing
            const pathParts = window.location.pathname.split('/');
            const cvr = pathParts[1];
            url = `/${cvr}${url}`;
          } else if (!subdomain) {
            // På produktion uden subdomain, brug CVR nummer routing
            const pathParts = window.location.pathname.split('/');
            const cvr = pathParts[1];
            url = `/${cvr}${url}`;
          }
          // If subdomain is true, keep the original url
        }
  
        return (
          <a 
            key={i}
            href={url}
            className="text-blue-600 hover:text-blue-800 hover:underline"
          >
            {linkText}
          </a>
        );
      } else if (i % 3 === 0) {
        // Normal tekst
        return part;
      }
      // Skip URL parts
      return null;
    });
};

export default function HeroLayout({ content, themeClasses, subdomain }) {
    return (
        <div>
            {/* Hero Section */}
            <div className="relative">
                {/* Background with conditional image */}
                <div 
                    className={`absolute inset-0 ${
                        !content.hero?.backgroundImage 
                            ? `bg-gradient-to-r ${themeClasses.gradient}` 
                            : ''
                    }`}
                >
                    {content.hero?.backgroundImage && (
                        <>
                            <div 
                                className="absolute inset-0 bg-cover bg-center"
                                style={{ backgroundImage: `url('${content.hero?.backgroundImage}')` }}
                            />
                            {/* Overlay for better text readability */}
                            <div className={`absolute inset-0 bg-gradient-to-r ${themeClasses.overlay}`} />
                        </>
                    )}
                </div>

                {/* Hero Content */}
                <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
                    <div className="text-center">
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-montserrat text-white mb-6">
                            {content.hero?.title}
                        </h1>
                        <p className={`text-xl md:text-2xl ${themeClasses.lightText}`}>
                            {content.hero?.subtitle}
                        </p>
                    </div>
                </div>
            </div>

            {/* Main Content Section */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                <div className="grid md:grid-cols-2 gap-12 items-start">
                    {/* Text Content */}
                    <div className="prose prose-lg max-w-none">
                        {content.main.content && content.main.content.split('\n\n').map((paragraph, index) => (
                            <p key={index} className="text-gray-700 mb-6 leading-relaxed">
                                {parseLinks(paragraph, subdomain)}
                            </p>
                        ))}
                    </div>

                    {/* Image */}
                    {content.main.image && (
                        <div className="relative">
                            <img 
                                src={content.main.image} 
                                alt=""
                                className="w-full h-auto rounded-lg shadow-lg"
                            />
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}